import server from 'api/server';
import React, { useState } from 'react';
import Modal from 'react-responsive-modal';
import { toast } from 'react-toastify';

const DeleteDocumentModal = ({ open, onClose, file }) => {
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);

  const onDelete = async () => {
    try {
      setLoading(true);
      const {
        data: { safe, success }
      } = await server.delete(`/documents/${file.id}`);
      if (!safe) {
        setLoading(false);
        setDisabled(true);
        setError('This document is in use and cannot be deleted!');
      }
      if (success) {
        onClose();
        setError('');
        setDisabled(false);
        setLoading(false);
        toast.info('Document deleted successfully.');
      }
    } catch (error) {
      setLoading(false);
      toast.info('Something went wrong!');
    }
  };
  return (
    <Modal
      open={open}
      onClose={() => {
        onClose();
        setDisabled(false);
        setError('');
      }}
      closeOnOverlayClick={false}
    >
      <div className="modal_top">
        <h3 className="title is-h3">Delete Document</h3>
        <div className="field">
          {!error && (
            <p>
              This will permanently remove the document. This action cannot be
              undone.
            </p>
          )}
          {error && <p className="help is-danger">{error}</p>}
        </div>
        <hr />
        <div className="field is-grouped">
          <div className="control">
            <button
              id="delete-document-modal-button-delete"
              disabled={disabled}
              onClick={onDelete}
              className={`button is-info is-small is-danger ${
                loading ? 'is-loading' : ''
              }`}
            >
              Delete Document
            </button>
          </div>
          <div className="control">
            <button
              id="delete-document-modal-button-cancel"
              onClick={() => {
                onClose();
                setDisabled(false);
                setError('');
              }}
              className="button is-info is-small is-light"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteDocumentModal;
